import React from 'react'
import { Link } from 'gatsby'
import './ContractVehiclesContent.scss'
import CallToActionBanner from '../../CallToActionBanner/CallToActionBanner'

export class ContractVehiclesContent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hideForm: false,
    }
  }

  render() {
    return (
      <div className="contract-vehicles-content">
        <div className="split light subheader-block">
        <div className="row">
            <div className="col-sm-5">
              <img src="/gsalogo.png" />
            </div>
            <div className="col-sm-7">
              <div className="title">GSA MAS</div>
              <div className="description">
                Rackner is on the GSA Multiple Award Schedule for SIN 54151S
                <br></br>
                Rackner is also on SIN 54151S, 518210C and HACS using our JV, RacknerWolf, LLC
                <br></br>
                <div
                  style={{
                    fontSize: '17px',
                    marginTop: '10px',
                    fontWeight: 'bold',
                  }}
                >
                  Contract #: 47QTCA23D006L
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-5">
              <img
                src="/sewp-vi-contract-holder.png"
                alt="NASA SEWP VI Contract Holder"
              />
            </div>
            <div className="col-sm-7">
              <div className="title">NASA SEWP VI</div>
              <div className="description">
                Rackner is a NASA SEWP VI contract holder for Category B
                (Enterprise-Wide ITC/AV Service Solutions) and Category C
                (Mission-Based ITC/AV Service Solutions)
                <br></br>
                <div
                  style={{
                    fontSize: '17px',
                    marginTop: '10px',
                    fontWeight: 'bold',
                  }}
                >
                  Contract #: 80TECH26D0807 (Cat. B), 80TECH26D0298 (Cat. C)
                </div>
                <Link to="/contractvehicles/sewp-vi">
                  SEWP VI contract information and ordering guide
                </Link>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-5">
              <img src="/p1-marketplace.png" />
            </div>
            <div className="col-sm-7">
              <div className="title">Platform One Marketplace</div>
              <div className="description">
                Rackner is deemed awardable on the P1 Marketplace in DevSecOps Engineering Solutions, Agile Training and Workforce Development, Cloud Operations Services, Pipeline Integrations, Identity Management, FinOps Services, Edge Compute Services, Container Hardening Services, and more.
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-5">
              <img src="/seaport-nxg.png" />
            </div>
            <div className="col-sm-7">
              <div className="title">SeaPort NxG</div>
              <div className="description">
                Rackner is proud to support the US Navy on this vehicle for Engineering and Program Management Services
                <br></br>
                <div
                  style={{
                    fontSize: '17px',
                    marginTop: '10px',
                    fontWeight: 'bold',
                  }}
                >
                  Contract #: N0017825D7722
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-5">
              <img src="/stars3logo.jpeg" />
            </div>
            <div className="col-sm-7">
              <div className="title">8(a) STARS III</div>
              <div className="description">
                Rackner was awarded the STARS III GWAC Contract using our JV,
                Rackner Vision, LLC
                <br></br>
                <div
                  style={{
                    fontSize: '17px',
                    marginTop: '10px',
                    fontWeight: 'bold',
                  }}
                >
                  Contract #: 47QTCB22D0510
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-5">
              <img src="/aflogo.png" />
            </div>
            <div className="col-sm-7">
              <div className="title">ABMS IDIQ</div>
              <div className="description">
                Rackner was awarded the ABMS/JADC2 $950m IDIQ for our Edge,
                DevSecOps, and AI Capabilities across mission domains
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-5">
              <img src="/oasis-plus.jpg" />
            </div>
            <div className="col-sm-7">
              <div className="title">GSA OASIS+</div>
              <div className="description">
                RacknerVision, LLC is on the OASIS+ 8(a) track for the Management and Advisory Domain
                <br></br>
                <div
                  style={{
                    fontSize: '17px',
                    marginTop: '10px',
                    fontWeight: 'bold',
                  }}
                >
                  Contract #: 47QRCA25DA088
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-5">
              <img src="/aflogo.png" />
            </div>
            <div className="col-sm-7">
              <div className="title">AFLCMC/XA IDIQ</div>
              <div className="description">
                Rackner is a contract holder of the AFLCMC/XA IDIQ, a vehicle that supports software architecture and prototyping for the US Air Force
                <br></br>
                <div
                  style={{
                    fontSize: '17px',
                    marginTop: '10px',
                    fontWeight: 'bold',
                  }}
                >
                  Contract #: FA868423DB089
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-5">
              <img src="/darpa-eris.png" />
            </div>
            <div className="col-sm-7">
              <div className="title">DARPA ERIS</div>
              <div className="description">
                Rackner has an awardable solution for AI-enabled decision advantage for command and control on DARPA's Expedited Research Innovation System Marketplace
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-5">
              <img src="/tradewinds-marketplace-1.png" />
            </div>
            <div className="col-sm-7">
              <div className="title">Tradewinds Solutions Marketplace</div>
              <div className="description">
                Rackner has an awardable solution for AI-enabled decision advantage for C2 software on the DoD CDAO's Tradewinds Solutions Marketplace
              </div>
            </div>
          </div>
          <div
            style={{
              borderBottom: '1px solid #ddd',
              width: '800px',
              maxWidth: '100%',
              margin: '40px auto',
              marginTop: '0px',
            }}
          />
          <div className="row">
            <div className="col-sm-5">
              <img src="/HUBZoneCertified.png" />
            </div>
            <div className="col-sm-7">
              <div className="title">Hubzone Certified Business</div>
              <div className="description">
                Rackner is proud to be a HUBZone certified business located in
                College Park, Maryland.
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-5">
              <img src="/kubernetes-kcsp-color.png" />
            </div>
            <div className="col-sm-7">
              <div className="title">Kubernetes Certified Service Provider</div>
              <div className="description">
                Rackner is highly experienced with Kubernetes with employees
                holding Kubernetes Certifications including the CKA, CKS, and
                CKAD.
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-5">
              <img src="/aws-partner-logo.png" />
            </div>
            <div className="col-sm-7">
              <div className="title">
                Amazon Web Services Consulting Partner
              </div>
              <div className="description">
                We use AWS heavily and are an official Consulting Partner with
                significant DevOps expertise.
              </div>
            </div>
          </div>
        </div>
        <CallToActionBanner route={'insights'} linkText={'See Case Studies'} />
      </div>
    )
  }
}

export default ContractVehiclesContent